import { Editor } from '@tiptap/core';
import { useRichTextEditorContext } from 'mui-tiptap';
import { MenuButton, type MenuButtonProps } from 'mui-tiptap';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';

import { ListTypes, type ListTypeName } from './types';

const getClosestListType = (editor: Editor | null): ListTypeName | null => {
  if (!editor) return null;

  const { $from } = editor.state.selection;

  for (let depth = $from.depth; depth > 0; depth--) {
    const node = $from.node(depth);
    if (node.type.name === ListTypes.Bullet) return ListTypes.Bullet;
    if (node.type.name === ListTypes.Ordered) return ListTypes.Ordered;
  }

  return null;
};

export const MenuButtonBulletedList = (props: Partial<MenuButtonProps>) => {
  const editor = useRichTextEditorContext();

  if (!editor) {
    return null;
  }

  const closestList = getClosestListType(editor);

  return (
    <MenuButton
      tooltipLabel="Bulleted list"
      disabled={!editor.isEditable}
      IconComponent={FormatListBulletedIcon}
      selected={closestList === ListTypes.Bullet}
      tooltipShortcutKeys={['mod', 'Shift', '8']}
      onClick={() => editor.chain().focus().toggleBulletList().run()}
      {...props}
    />
  );
};

export const MenuButtonOrderedList = (props: Partial<MenuButtonProps>) => {
  const editor = useRichTextEditorContext();

  if (!editor) {
    return null;
  }

  const closestList = getClosestListType(editor);

  return (
    <MenuButton
      tooltipLabel="Ordered list"
      disabled={!editor.isEditable}
      IconComponent={FormatListNumberedIcon}
      tooltipShortcutKeys={['mod', 'Shift', '7']}
      selected={closestList === ListTypes.Ordered}
      onClick={() => editor.chain().focus().toggleOrderedList().run()}
      {...props}
    />
  );
};
